import styled from "styled-components";
import Invoice from "../../components/product/Invoice";
import AddressBookCheckout from "../../components/account/AddressBookCheckout";
import { useContext, useState } from "react";
import { AuthUserContext } from "../../context/AuthUserContext";
import AddressCardCheckout from "../../components/account/AddressCardCheckout";
import Transport from "../../components/account/Transport";
import Payment from "../../components/account/Payment";
import Logo from "../../components/animations/Logo";

//import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { paymentMethods } from "../../utils/global_const";
import CreditCardsCheckout from "../../components/stripe/CreditCardsCheckout";
import CardPaymentLink from "../../components/mollie/CardPaymentLink";

// const stripePromise = loadStripe(
//   "pk_test_51QI78aHyD45BjVAFFnBI17A25VDrrBQ94NJ23DJarIxnG5YPjwJGKiG2iKKIymERIFvJVxMUCjn3giAUHT7uIbtf00DsMkBivd"
// );
// const appearance = {
//   theme: "stripe",
// };

const Container = styled.main`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: var(--bg-100);
  padding-top: calc(var(--navbar-height));
  @media (min-width: 1040px) {
    min-height: 90vh;
    padding-top: calc(var(--navbar-height-desktop));
  }
`;
const Wrapper = styled.div`
  width: 94%;

  @media (min-width: 1040px) {
    padding: var(--spacing-xxl) 0;
    width: 100%;
    display: flex;
    position: relative; /* Ovo je potrebno za relativno pozicioniranje unutar roditelja */
    justify-content: space-between;
    max-width: var(--max-width-container);
  }
`;

const RightContainer = styled.div`
  @media (max-width: 768px) {
    margin-bottom: 120px;
  }
  @media (min-width: 1040px) {
    height: 60vh;
    max-height: 90vh;
    width: 400px;
    position: sticky;
  }
  @media (min-width: 768px) and (max-width: 1040px) {
    width: 100%;
  }
  @media (min-width: 1025px) {
    left: calc(
      (100vw - var(--max-width-container)) / 2 + var(--max-width-container) -
        700px
    );
    top: calc(var(--navbar-height-desktop));
  }
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  @media (min-width: 1040px) {
    width: calc(100% - 410px);
  }
`;
const RightWrapper = styled.div`
  @media (min-width: 1040px) {
    padding: 0 var(--spacing-xxl);
  }
`;
const InnerWrapper = styled.div`
  width: 100%;
  margin-bottom: var(--spacing-md);

  h2 {
    margin: 0;
    font-size: var(--font-size-large);
    color: var(--text-100);
    font-weight: 500;
  }
`;
const CheckoutMain = () => {
  const { userProfile } = useContext(AuthUserContext);
  const [address, setAddress] = useState(null);
  const [payment, setPayment] = useState(null);
  const [submit, setSubmit] = useState(false);
  //const [clientSecret, setClientSecret] = useState("");

  return (
    //<Elements options={{ appearance }} stripe={stripePromise}>
    <Container>
      {submit && <Logo />}
      <Wrapper>
        <LeftContainer>
          <InnerWrapper>
            <h2>
              {userProfile.first_name} {userProfile.last_name}
            </h2>
          </InnerWrapper>
          {userProfile?.addresses.length === 0 ? (
            <AddressBookCheckout />
          ) : (
            <>
              <AddressCardCheckout setAddress={setAddress} />
            </>
          )}
          <Transport />
          <Payment setPayment={setPayment} />
          {/* {payment && paymentMethods[1].name == payment && (
            <CreditCardsCheckout
              address={address}
              setClientSecret={setClientSecret}
            />
          )} */}
        </LeftContainer>
        <RightContainer>
          <Invoice
            address={address}
            payment={payment}
            setSubmit={setSubmit}
            clientSecret={""}
          />
        </RightContainer>
      </Wrapper>
    </Container>
    //</Elements>
  );
};

export default CheckoutMain;
